module.exports = "/_next/static/images/electricalConstruction-327dfe7e35b44b8624c56a79a0892870.webp";